import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@parkify/brand-tokens/tokens.css'
import '@parkify/find-parking/styles.css' // shared no-QR browse map styles
import '@parkify/account/styles.css'
import './index.css'
import { App } from './App'
import { ErrorBoundary } from './ErrorBoundary'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
)
